<div class="not-selected-tenant-container max-w-[300px] mx-auto">
  <app-horus-message-general 
    size="S" 
    nameIcon="searchIcon">
    {{ message }}
  </app-horus-message-general>
</div>